import Yox from 'yox'

import template from './template/OptionGroup.hbs'

import {
  RAW_STRING,
} from '../constant'

export default Yox.define({

  template,

  name: 'bell-OptionGroup',

  propTypes: {
    label: {
      type: RAW_STRING,
    },
    className: {
      type: RAW_STRING,
    },
    style: {
      type: RAW_STRING,
    }
  },
})